import z from 'zod'
import {ERROR_DEFAULT} from 'features/common/core/errors'
import api from 'features/common/transport'

const sendCodeResponseSchema = z.object({
    card: z.string(),
    tabletop: z.string(),
    sticker: z.string(),
})
const getQRCards = async ({
    language,
    qrId,
}: {
    language: string
    qrId: string
}): Promise<{card: string; tabletop: string; sticker: string}> => {
    const res = await api.get(`stickers/${language}/${qrId}`, {
        prefixUrl: window.location.origin,
    })

    const parseRes = sendCodeResponseSchema.safeParse(await res.json())
    if (parseRes.success) {
        return parseRes.data
    }

    throw new Error(ERROR_DEFAULT)
}
export default getQRCards
